import React from 'react';
import FacturesTable from '../SidebarOptions/FactureEtablie.js'
import ClientsTable from '../SidebarOptions/ConsulterClient.js'
import AjouterFacture from '../SidebarOptions/AjouterFacture.js'
import AjouterHotel from '../SidebarOptions/AjouterHotel.js'
import AjouterRoom from '../SidebarOptions/AjouterRoom.js'
import AjouterOrganisme from '../SidebarOptions/AjouterOrganisme.js'
import Listresident from '../SidebarOptions/Listresident.js'
import UploadClient from '../SidebarOptions/UploadClient.js'
import Reservation from '../SidebarOptions/Reservation.js'
import GestionUtilisateur from '../SidebarOptions/GestionUtilisateur.js'
import FactureDocument from '../SidebarOptions/ConsulterFactDocument.js'
import ReservationDocument from '../SidebarOptions/ConsulterReserDocument.js'
import DetailFactures from '../SidebarOptions/detailfactures.js';
import ConsulterReservation from '../SidebarOptions/ConsulterReservation.js';
import Dashboard from '../SidebarOptions/dashboard.js';
import AjouterPrixchambre from '../SidebarOptions/Ajouterprixchambre.js';
import UploadReservation from '../SidebarOptions/uploadReservationFile.js';




import '../../Css/MainContent.css';






const MainContent = ({ selectedOption, isVisible,isSumited, onToggle, isSumitedReserv }) => {
  const renderContent = () => {
    switch (selectedOption) {
      case 'option1-1':
        return <AjouterFacture onSubmit={isSumited}/>;
      case 'option1-2':
        return <FacturesTable />;
      case 'option1-3':
        return <Listresident />;
      case 'option1-4':
          return <DetailFactures />;
      case 'option2-1':
        return <Reservation onSubmitReserv={isSumitedReserv}/>;
      case 'option2-2':
        return <ConsulterReservation />;
      case 'option3-1':
        return <FactureDocument />;
      case 'option3-2':
        return <ReservationDocument />;
      case 'option4-1':
        return  <AjouterRoom />;
      case 'option4-2':
        return <AjouterOrganisme />;
      case 'option4-3':
        return <AjouterHotel />;
      case 'option4-4':
        return <AjouterPrixchambre />;
      case 'option4-5':
        return <UploadReservation />;
      case 'option5':
        return <ClientsTable />;
      case 'option6':
        return <GestionUtilisateur />;
      case 'option7':
        return <Dashboard />;
      default:
        return <div>Select an option from the menu</div>;
    }
  };


  return (
    <div className='MainContent__main' onClick={onToggle}>
        {renderContent()}
    </div>
  );
};

export default MainContent;
